module.exports = __webpack_public_path__ + "img/who-are-we-img-3.97b9cacd.png";